<template>
  <div class="item__info mx-5">
    <div class="text-center" v-if="!isLoading">

      <div class="divFotoProfilo">
        <img id="fotoProfilo" class="imgDivFotoProfilo" alt="Foto tesserato"
             :src="'http://www.federbridge.it/FotoAgonisti/' + playerCode + '.jpg'"
             onerror="this.src='http://www.federbridge.it/Mobile/Immagini/nofoto.jpg'">
      </div>
      <div class="playerGreeting mt-3">
        {{ $t('welcome.hello') }} <strong>{{ playerName }}</strong>
      </div>

      <div class="contestInfo">
        <div class="row">
          <div class="col-md-12">
            {{ $t('welcome.atEvent') }}<br>
            <span class="contestName">{{ tournamentName }}</span>
          </div>
          <div v-if="hasCollectorContest" class="col-md-12">
            <b-form-checkbox v-model="collectorSwitch" name="check-button" switch size="lg">{{ $t('welcome.showNational') }}
            </b-form-checkbox>
          </div>
        </div>
        <!-- Torneo non in corso -->
        <div v-if="!isRunning" class="row text-center mt-2">
          <div class="col-md-12 notRunningMsg">{{ $t('welcome.notRunning') }}</div>
        </div>
        <div v-else class="row text-center">
          <template v-if="currentTableState != null && currentTableState.position > -1">
            <div class="col-md-12">
              {{ $t('welcome.playingRound') }} <strong>{{ currentRound }}</strong></div>
            <div class="col-md-12">
              {{ $t('welcome.currentPosition') }} <strong>{{ currentSectorSigla }} {{ currentTable }}
              {{ currentPosition }}</strong></div>
          </template>
          <template v-else-if="isPlaying && contestType === 0">
            <div class="col-md-12">
              <p>{{ $t('welcome.noPosition') }}</p>
              <table-subscribing class="my-5"></table-subscribing>
            </div>
          </template>
        </div>
      </div>
    </div>
    <PuSkeleton :count="5" v-else></PuSkeleton>

    <template v-if="!isLoading && isRunning && (isTd || this.playerCode === 'VISITOR')">
      <div class="div-cont-table" v-for="sector of Object.values(sectors)" :key="sector.Sigla">
        <h5>{{ $t('welcome.sectorTitle') }} {{ sector.Sigla }} - {{ sector.Descrizione }}</h5>
        <div v-if="Math.max(...Object.keys(sector.Rounds).map(i => parseInt(i))) >= sector.CurrentRound">
          <div class="text-left">
            <div v-if="sector.JumpAfterRound > 0">
              <b-icon-skip-forward></b-icon-skip-forward>
              {{ $t('welcome.jumpAfterRound') }}
            </div>
            <div v-if="sector.ScrambleAfterRound > 0">
              <b-icon-arrow-left-right></b-icon-arrow-left-right>
              {{ $t('welcome.scrambleAfterRound') }}
            </div>
          </div>
          <div></div>
          <table class="w-100 table-girone mt-4">
            <tr>
              <td></td>
              <td v-for="roundNumber of visibleRounds(sector)"
                  :key="roundNumber"
                  class="turno-gioco align-bottom">
                <b-icon-skip-forward v-if="roundNumber === sector.JumpAfterRound"
                                     class="d-block m-auto"></b-icon-skip-forward>
                <b-icon-arrow-left-right v-if="roundNumber === sector.ScrambleAfterRound"
                                         class="d-block m-auto"></b-icon-arrow-left-right>
                {{ roundNumber }}
              </td>
              <td class="mancanti-td mancanti-header align-bottom">M</td>
            </tr>

            <tr v-for="[openRoomTableNumber, closedRoomTableNumber] of tablesOfSector(sector)"
                :key="openRoomTableNumber">
              <td class="tavolo-td">
                {{ $t('welcome.tableShort') }} {{ openRoomTableNumber }}
              </td>
              <td v-for="roundNumber of visibleRounds(sector)" :key="roundNumber">
                <table class="w-100">
                  <tr>

                    <td v-if="sector.Rounds[roundNumber].Tables[openRoomTableNumber] == null"></td>

                    <td v-else-if="sector.Rounds[roundNumber].Tables[openRoomTableNumber].IsBye"
                        class="bye-td">B
                    </td>

                    <template v-else>
                      <td :class="computeRoundClass(sector.Rounds[roundNumber].Tables[openRoomTableNumber])">
                        {{
                          sector.Rounds[roundNumber].Tables[openRoomTableNumber].PlayedBoards.length
                        }}
                      </td>
                      <template v-if="contestType === 0">
                        <td :class="computeRoundClass(sector.Rounds[roundNumber].Tables[closedRoomTableNumber])"
                            style="width: 50%"
                            v-html="closedRoomTableNumber !== undefined ? sector.Rounds[roundNumber].Tables[closedRoomTableNumber].PlayedBoards.length : '&nbsp;'">
                        </td>
                      </template>
                    </template>
                  </tr>
                </table>
              </td>
              <td class="mancanti-td">
                {{ missingOfTable(sector, openRoomTableNumber, closedRoomTableNumber).left }}/{{
                  missingOfTable(sector, openRoomTableNumber, closedRoomTableNumber).right
                }}
              </td>
            </tr>

            <tr class="mancanti-totali-tr">
              <td></td>
              <td v-for="roundNumber of visibleRounds(sector)" :key="roundNumber"></td>
              <td class="mancanti-td">
                {{ missingTotals(sector).left }}/{{ missingTotals(sector).right }}
              </td>
            </tr>
          </table>
        </div>
        <div v-else style="font-size: 3rem" class="m-0"><b-icon-check variant="success"></b-icon-check></div>
      </div>
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import TableSubscribing from "../components/bridgeSelection/TableSubscribing";

export default {
  name: 'Welcome',
  components: {TableSubscribing},
  data() {
    return {
      isLoading: true
    }
  },
  mounted() {
    this.isLoading = this.players === null;
  },
  computed: {
    ...mapGetters({
      currentTableState: 'tournament/currentTableState',
      players: 'players/playersList',
      teamPlayers: 'players/teamPlayers',
      tournamentName: 'tournament/tournamentName',
      isRunning: 'tournament/isRunning',
      contestType: 'tournament/contestType',
      directors: 'tournament/directors',
      playerCode: 'webApp/playerCode',
      playerName: 'webApp/playerName',
      sectors: 'tournament/contestCurrentStateMap',
      isVisitor: 'webApp/isVisitor',
      isTd: 'webApp/isTd',
      isPlaying: 'webApp/isPlaying',
      useCollectorContest: 'webApp/useCollectorContest',
      hasCollectorContest: 'webApp/hasCollectorContest'
    }),
    collectorSwitch: {
      get() {
        return this.useCollectorContest;
      },
      set(newValue) {
        this.isLoading = true;
        this.changeContext(newValue);
      }
    },
    currentRound() {
      return this.currentTableState?.round;
    },
    currentTable() {
      return this.currentTableState?.table;
    },
    currentSectorSigla() {
      if (this.currentTableState == null || this.sectors.Phases == null) {
        return '';
      }
      return this.sectors.Phases[this.currentTableState.phase].Series[this.currentTableState.serie].Sessions[this.currentTableState.session].Groups[this.currentTableState.sector].Sigla;
    },
    currentPosition() {
      if (this.currentTableState == null || this.sectors.Phases == null) {
        return '';
      }
      return this.$t('positions.' + this.currentTableState.position);
    }
  },
  methods: {
    ...mapActions({
      changeContext: 'webApp/changeContext',
    }),
    tablesOfSector(sector) {
      const allTables = Object.values(sector.Rounds).flatMap(rnd => Object.entries(rnd.Tables));

      const openRoomTablesNumber = [...new Set(allTables.filter(entry => entry[1].Room === 0)
          .map(t => parseInt(t)))]
          .sort((t1, t2) => t1 - t2);

      const closedRoomTablesNumber = [...new Set(allTables.filter(entry => entry[1].Room === 1)
          .map(t => parseInt(t)))]
          .sort((t1, t2) => t1 - t2);

      //Array.zip
      const zip = (a, b) => Array.from(Array(Math.max(b.length, a.length)), (_, i) => [a[i], b[i]]);

      //[openRoomTableNumber, closedRoomTableNumber]
      return zip(openRoomTablesNumber, closedRoomTablesNumber);
    },
    missingOfRoundTable(sector, roundNumber, tableNumber) {
      if (tableNumber === undefined) {
        return 0;
      }
      const table = sector.Rounds[roundNumber]?.Tables?.[tableNumber];
      if (table == null || table.IsBye) {
        return 0;
      }
      return Math.max(0, (table.Boards?.length ?? 0) - (table.PlayedBoards?.length ?? 0));
    },
    missingOfTable(sector, openRoomTableNumber, closedRoomTableNumber) {
      if (this.contestType === 0) {
        return {
          left: this.missingOfRoundTable(sector, sector.CurrentRound, openRoomTableNumber),
          right: this.missingOfRoundTable(sector, sector.CurrentRound, closedRoomTableNumber)
        };
      }

      const allRounds = Object.keys(sector.Rounds).map(i => parseInt(i));
      return {
        left: this.missingOfRoundTable(sector, sector.CurrentRound, openRoomTableNumber),
        right: allRounds.reduce((sum, roundNumber) =>
            sum + this.missingOfRoundTable(sector, roundNumber, openRoomTableNumber), 0)
      };
    },
    missingTotals(sector) {
      return this.tablesOfSector(sector)
          .map(([openRoomTableNumber, closedRoomTableNumber]) =>
              this.missingOfTable(sector, openRoomTableNumber, closedRoomTableNumber))
          .reduce((tot, missing) => ({left: tot.left + missing.left, right: tot.right + missing.right}),
              {left: 0, right: 0});
    },
    computeRoundClass(round) {
      switch (round?.PlayedBoards?.length ?? -1) {
        case -1:
          return "";
        case 0:
          return "red-td";
        case round.Boards.length:
          return "green-td";
        default:
          return "yellow-td"
      }
    },
    visibleRounds(sector) {
      //  pairs contest -> pre pre pre curr post post post
      //  teams contest -> pre curr post
      const prePostColumns = this.contestType === 0 ? 1 : 2;
      const allRounds = Object.keys(sector.Rounds).map(i => parseInt(i)).sort();

      if (allRounds.length <= prePostColumns * 2 + 1) {
        return allRounds;
      }

      const minRound = Math.min(...allRounds);
      const maxRound = Math.max(...allRounds);
      const currentRound = sector.CurrentRound;
      let startFrom = Math.max(currentRound - prePostColumns, minRound);

      if (startFrom + (prePostColumns * 2) > maxRound) {
        startFrom = maxRound - (prePostColumns * 2);
      }

      return Array.from({length: prePostColumns * 2 + 1}, (_, i) => i + startFrom);
    }
  },
  watch: {
    players() {
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
.text-message {
  margin-bottom: 30px;
}

.notRunningMsg {
  font-size: 1.1rem;
  color: #64748b;
  font-style: italic;
}

.div-cont-table {
  background: #fff;
  border-radius: 0.875rem;
  box-shadow: 0 2px 14px rgba(30, 58, 95, 0.08);
  padding: 1.25rem 1rem 1.5rem;
  margin-top: 1rem;
  text-align: center;

  h5 {
    font-size: 0.88rem;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 1rem;
  }
}

td {
  max-width: 22px;
  height: 22px;
}

.table-girone tr {
  border-bottom: 2px solid #f0f4f8;
}

.table-girone {
  overflow-y: scroll;
}

.turno-gioco {
  font-weight: 700;
  color: #1e3a5f;
  font-size: 0.8rem;
}

td.mancanti-td {
  width: 1%;
  max-width: none;
  white-space: nowrap;
  text-align: center;
  padding-left: 3px;
  padding-right: 1px;
  border-left: 2px solid #1e3a5f;
  background-color: #eef2f7;
  font-size: 0.68rem;
  font-weight: 700;
  color: #1e3a5f;
}

td.mancanti-header {
  font-size: 0.7rem;
}

.mancanti-totali-tr {
  border-bottom: none;
}

.mancanti-totali-tr td.mancanti-td {
  border-top: 2px solid #1e3a5f;
}

.red-td {
  background-color: #dc2626;
  color: white;
  border-radius: 3px;
}

.contestName {
  color: #1e3a5f;
  font-weight: 700;
  font-size: 1.05rem;
}

.yellow-td {
  background-color: #fde68a;
  color: #7c5e00;
  border-radius: 3px;
}

.bye-td {
  background-color: #c8973f;
  color: #fff;
  border-radius: 3px;
}

.green-td {
  background-color: #bbf7d0;
  color: #145a2e;
  border-radius: 3px;
}

td.tavolo-td {
  padding-right: 4px;
  white-space: nowrap;
  text-align: right;
  font-size: 0.78rem;
  color: #64748b;
  font-weight: 500;
}

.divFotoProfilo {
  z-index: 0;
  height: 96px;
  width: 96px;
  position: relative;
  border-radius: 50%;
  border: 3px solid #1e3a5f;
  overflow: hidden;
  margin: 0 auto;
  box-shadow: 0 4px 16px rgba(30, 58, 95, 0.18);
}

.imgDivFotoProfilo {
  z-index: 1;
  position: absolute;
  left: -50%;
  right: -50%;
  top: 0;
  margin: auto;
  height: 120px;
  border: 0;
}

.contestInfo {
  background: #fff;
  border-radius: 0.875rem;
  box-shadow: 0 2px 14px rgba(30, 58, 95, 0.08);
  padding: 1rem 1.25rem;
  margin-top: 0.75rem;
  margin-bottom: 0.5rem;
}

.playerGreeting {
  font-size: 1rem;
  color: #64748b;
  margin-bottom: 0.25rem;

  strong {
    color: #1a2638;
    font-size: 1.15rem;
  }
}

.item__info {
  padding-bottom: 2rem;
}
</style>
